import { render, staticRenderFns } from "./SerialNumberAlertModal.vue?vue&type=template&id=a70e2f30&scoped=true&lang=pug"
import script from "./SerialNumberAlertModal.vue?vue&type=script&lang=js"
export * from "./SerialNumberAlertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70e2f30",
  null
  
)

export default component.exports